export default {
  data: () => ({
    translations: {
      title: {
        el: 'Ανταμοιβή με κάθε επίσκεψη στο κατάστημα',
        en: 'Reward with presence in the store',
        it: 'Ricompensa con la presenza in negozio',
      },
      info_points: {
        el: 'Οι πελάτες κερδίζουν πόντους όταν επισκέπτονται το κατάστημά σας.',
        en: `Customers win points when they visit your store.`,
        it: 'I clienti guadagnano punti quando visitano il tuo negozio.',
      },
      info_cashback: {
        el: 'Οι πελάτες κερδίζουν cashback όταν επισκέπτονται το κατάστημά σας.',
        en: `Customers win cashback when they visit your store.`,
        it: 'I clienti guadagnano cashback quando visitano il tuo negozio.',
      },
    },
  }),
};
